export default {
  organization: {
    action: "Go to Organization Info",
    subtitle:
      "Add your company information and office locations worldwide, and upload your logo for future use.",
    title: "Set up your organization information",
    description:
      "Complete your company information, upload your logo, and add your worldwide branch locations and terms & conditions.",
    item_1_title: "Company Information",
    item_1_steps: [
      "Go to <strong>Organization</strong>",
      "Click on <strong>Company Information</strong>",
      "Upload your organization logo.",
      "Insert contact information such as business email address and phone number.",
      "Add your main office address and include the terms & conditions",
    ],
    go_company_info: "Go to Company Information",
  },
  system_setup: {
    title: "System Setup",
    subtitle:
      "Enable Apple Business Manager for zero-touch device enrollment. Make bulk app and license purchases easy by enabling ADE and VPP tokens.",
    action: "Go to System Setup",
    description:
      "Enable Apple Business Manager for zero-touch device enrollment. Make bulk app and license purchases easy by enabling ADE and VPP tokens.",
    apn: {
      title: "APNs Certificate Setup",
      steps: [
        "Go to the <strong>Organization</strong> tab and select <strong>System Setups</strong>.",
        "To activate your APNs Certificate, click on <strong>Configure</strong>.",
        "Download the CSR",
        "Enter your Apple ID",
        "Sign in to the Apple Portal and upload the CSR file",
        "Download the signed certificate provided by Apple and upload it on Trio.",
      ],
    },

    dep: {
      title: "Automated Device Enrollment Activation (DEP)",
      steps: [
        "Navigate to the <strong>Organization</strong> tab and select System Setups.",
        "Then, click on <strong>Configure.</strong>",
        "Download the Trio Token and enter your Apple ID.",
        "Sign in to the Apple Portal and upload the certificate",
        "Download the certificate signed by Apple and upload it to Trio.",
      ],
    },
    vpp: {
      title: "Volume Purchase Program Activation (VPP)",
      steps: [
        "Go to the <strong>Organization</strong> section and then proceed to <strong>System Setups.</strong>",
        "Scroll down to find <strong>VPP Token</strong> and click <strong>Configure.</strong>",
        "Sign in to your Apple Business Portal and download your VPP token.",
        "Finally, upload the token to Trio.",
      ],
    },
  },
  add_employee: {
    action: "Add Users",
    title: "Add Users or Integration Data",
    description:
      "Add users manually or import their data by integrating with other third-party platforms like Microsoft 365 or Google Workspace.",
    subtitle:
      "You can add users one by one, upload a CSV file, or import their data by integrating with third-party platforms like Microsoft Office 365 or Google Workspace.",
    csv: {
      title: "Upload CSV",
      action: "Add from CSV",
      steps: [
        "Go to <strong>Users.</strong>",
        "Click <strong>Add User.</strong>",
        "Choose <strong>Add from CSV.</strong>",
        "Select <strong>Download Template</strong>, download and open the file, and enter the user’s data.",
        "Save the changes, drag and drop the file on Trio’s web panel, and select <strong>Upload</strong>.",
      ],
    },
    gws: {
      title: "Google Workspace",
      action: "Import from Google Workspace",
      steps: [
        "Go to <strong>Users.</strong>",
        "Click <strong>Add User</strong> on the top right.",
        "Choose <strong>Import from Google Workspace.</strong>",
        "Select <strong>Connect</strong>, and follow the instructions.",
      ],
    },
    office: {
      title: "Integration with Office 365",
      action: "Import from Office 365",
      steps: [
        "Go to <strong>Users.</strong>",
        "Click <strong>Add User</strong> on the top right.",
        "Choose <strong>Import from Office 365.</strong>",
        "Select <strong>Connect</strong>, and follow the instructions.",
      ],
    },
  },
  software: {
    title: "Software Management",
    description:
      "Handpick and assign all applications to different autopilot based on their needs. Keep all software updated to avoid vulnerabilities.",
    subtitle:
      "Handpick and assign all applications to different autopilot based on their needs. Keep all software updated to avoid vulnerabilities.",
    action: "Add Applications",
    app_store: {
      steps: [
        "To add apps from the App Store, go to <strong>Software Management.</strong>",
        "Click <strong>Add Application</strong> on the top right.",
        "Select <strong>Add from App Store.</strong>",
      ],
      title: "Add from App Store",
      action: "Go to Add Application",
    },
    windows: {
      steps: [
        "To add Windows apps, go to <strong>Software Management.</strong>",
        "Click <strong>Add Application</strong> on the top right.",
        "Click <strong>Add Windows apps.</strong>",
      ],
      title: "Add Windows Apps",
      action: "Go to Add Application",
    },
    custom: {
      steps: [
        "Go to <strong> Software Management.</strong>",
        "Click <strong>Add Application</strong> on the top right.",
        "Click <strong>Custom Application.</strong>",
        "Upload your custom app.",
      ],
      title: "Add Custom Application",
      action: "Go to Add Application",
    },
  },
  security: {
    title: "Create Security",
    description:
      "Create policy profiles and assign them to devices within your organization to ensure utmost security and compliance with the latest regulations.",
    action: "Create your Security",
    profile_security: {
      action: "Go to Security",
      title: "Create your first Security",
      steps: [
        "To create Security, navigate through <strong>Profile Management.</strong>",
        "Click on <strong> Security.</strong>",
        "Choose <strong>Create First Profile.</strong>",
        "Now, you can set general or detailed restrictions that will be applied on all devices.",
      ],
    },
  },
  configuration: {
    title: "Create your Configuration",
    description:
      "Create your custom configuration or choose among our templates. Apply these templates to all devices within your organization.",
    action: "Create Configuration",
    profile_configuration: {
      action: "Go to Configuration",
      title: "Create your first configuration",
      steps: [
        "To create your first configuration, navigate to <strong>Profile Management.</strong>",
        "Select <strong> Configuration.</strong>",
        "Begin by assigning a unique name to the profile.",
        "Proceed with the process based on the device’s ownership.",
        "Choose a framework for your profile.",
        "Now establish your preferred configurations for various settings such as Wi-Fi, LDAP, AirPrint, HTTP Proxy, passcode, and VPN.",
      ],
    },
  },
  department: {
    title: "Create Group",
    description:
      "Create different group and grant them the necessary accessibilities to boost productivity within your organization.",
    action: "Create Group",
    create: {
      action: "Go to Autopilot",
      title: "Create your first group",
      steps: [
        "To create different autopilot for your enterprise, navigate to the <strong>Autopilot</strong> tab.",
        "Click on <strong>Create First Autopilot.</strong>",
        "Give your autopilot a name and choose a manager for it.",
        "Add a description for your autopilot. (Optional)",
        "Lastly, tap on <strong>Create.</strong>",
      ],
    },
  },
  onboard: {
    title: "On-Board User",
    description:
      "Bring new users on board by inputting their details, providing essential access, and assigning devices.",
    action: "Go to On-Board",
    create: {
      action: "Go to On-Board",
      title: "Onboard your first user",
      steps: [
        "Go to the <strong>Users</strong> tab onboard an user from scratch on Trio.",
        " Click on <strong>On-board.</strong>",
        "In the <strong>Choose Your User</strong> section, you can choose from existing users or skip this part.",
        'In the following section, please enter user information manually and then click "<strong>Next.</strong>"',
        "Choose a job title.",
        "Select their autopilot.",
        "Assign their devices.",
        "Please select policy profiles for your device.",
        "Assign apps and grant them the necessary access permissions.",
      ],
    },
  },
  enroll: {
    title: "Enroll devices",
    description:
      "Enroll devices manually and assign them to different users and autopilot. Enjoy a centralized overview of all devices.",
    subtitle:
      "Enroll devices manually or with zero-touch enrollment and assign them to different users and autopilot. Enjoy a centralized overview of all devices.",
    action: "Enroll devices",
    credential: {
      action: "Add New Device",
      title: "Enrollment via Credentials",
      steps: [
        "To enroll devices using credentials, navigate to the <strong> Devices </strong> section.",
        "Select <strong>Inventory.</strong>",
        "Click <strong>Add New Device.</strong>",
        "Now, follow the link and input the provided credentials, which should include a business email address and password, to successfully enroll the device.",
      ],
    },
    pairCode: {
      action: "Add New Device",
      title: "Enrollment via Pair-Code",
      steps: [
        "To enroll devices using pair-codes, navigate to the <strong> Devices</strong> section.",
        "Select <strong>Inventory.</strong>",
        "Click <strong>Add New Device.</strong>",
        "Find <strong>Use Pair-Code in Link.</strong>",
        "Generate a new pair-code, and copy it.",
        "Click on the link provided and select <strong>Enroll via Pair-Code.</strong>",
        "The final step is to insert the pair code and click <strong>Confirm.</strong>",
        "Keep in mind that you can revoke and change the pair code at any time.",
      ],
    },
  },
  global: {
    action: "Global Setting",
    title: "Global Setting",
    description:
      "Choose new admins and grant them different access levels for better enterprise management. Give them roles such as super admin, IT admin, and HR admin.",
    admin: {
      action: "Admin Management",
      title: "Admin Management",
      steps: [
        "To manage admins, go to the <strong>Organizations</strong> section.",
        "Click on <strong>Global Settings.</strong>",
        "In the <strong>Admin Management</strong> tab, you will find a full list of all admins and their roles.",
        "Click on the three dots to alter their access levels, edit or revoke them.",
      ],
    },
    new_admin: {
      action: "Admin Management",
      title: "Add New Admin",
      steps: [
        "To manage admins, go to the <strong>Organizations</strong> tab.",
        "Click on <strong>Global Settings.</strong>",
        "Click <strong>Add New Admin</strong> at the top right.",
        "Select an user and assign them a role. Keep in mind that each role has a different level of access.",
      ],
    },
    security: {
      action: "Go To Security",
      title: "Security",
      steps: [
        "to change security settings, go to the <strong>Organizations</strong>tab.",
        "Click on <strong>Global Settings.</strong>",
        "Go to <strong>Security</strong> tap.",
        "Now you can set password policies, such as minimum password length, complexity level, expiration rules, and MFA activation.",
      ],
    },
  },
  completed_title: "you completed {{progress}}% of process",
  title:
    "You need to take some steps to get the most out of Trio and manage your Company easily and Securely.",
};
